import React, { Component, Fragment } from 'react';
import AuthService from './services/AuthService'
import PropTypes from 'prop-types';
import { API, Storage } from 'aws-amplify';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import SvgIcon from 'react-icons-kit';
import { remove, fileTextO} from 'react-icons-kit/fa/'
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import { withSnackbar } from 'notistack';
import FileDrop from 'react-file-drop';
import {v4 as uuidv4} from 'uuid/v4';
import moment from 'moment'

const basePath = "images/extraPlans/"

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    minWidth: 500,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: 0,
    width: 400,
  },
  menuButton:{
    margin:5
  },
});

const initialState = {
  title: "",
  subTitle: "",
  body: "",
  price: "",
  priority: "",
  //検証用
  // title: "ボジョレー・ヌーヴォー2019 セットプラン",
  // subTitle: "今年もこの季節がやってきました",
  // body: "a",
  // price: "1800",
  // priority: "1",
  topImage: "",
  topImageUrl: "",
  topImageCaution: false,
  mainImage1: "",
  mainImage1Url: "",
  mainImage1Caution: false,
  mainImage2: "",
  mainImage2Url: "",
  mainImage2Caution: false,
  refTitle: "",
  refSubTitle: "",
  refBody: "",
  refPrice: "",
  refPriority: "",
  refTopImageUrl: "",
  refMainImage1Url: "",
  refMainImage2Url: "",
  extraPlans: [],
  extraPlansPosted: [],
  extraPlansNotPosted: [],
  executing: false,
  deleteOpen: false,
  deleteExtraPlanId: "",
  refOpen: false,
  refExtraPlanId: "",
  scroll: "paper",
};

function humanFileSize(size) {
    if (size < 1024) return size + ' B'
    let i = Math.floor(Math.log(size) / Math.log(1024))
    let num = (size / Math.pow(1024, i))
    let round = Math.round(num)
    num = round < 10 ? num.toFixed(2) : round < 100 ? num.toFixed(1) : round
    return `${num} ${'KMGTPEZY'[i-1]}B`
}

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class ExtraPlans extends Component {

  constructor(props) {
    super(props);
    this.state = initialState;
    this.authApi = new AuthService();
  }

  setExtraPlans = (extraPlans) => {
    let extraPlansPosted = []
    let extraPlansNotPosted = []

    extraPlans.map((plan) => {
      if(plan.status === "posted"){
        extraPlansPosted.push(plan)
      }else{
        extraPlansNotPosted.push(plan)
      }
      return false
    })

    this.setState({
      extraPlans: extraPlans,
      extraPlansPosted: extraPlansPosted,
      extraPlansNotPosted: extraPlansNotPosted,
    })
  }

  getExtraPlans = () => {
    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/search-extra-plans'; //replace this with the path you have configured on your API

    API.get(apiName, path).then(response => {
      console.log(response);

      let extraPlans = response.extraPlans

      this.setExtraPlans(extraPlans)

    }).catch(error => {
      console.log(error)
    });
  }

  componentWillMount(){

    this.getExtraPlans();

    this.authApi.isLogin()
    .then(
      (login) => {
        if(!login){
          this.props.history.push('/login');
        }
      }
    );
  }

  handleChange = (event, key) => {
    this.setState({
      [key] : event.target.value
    });

  }

  handleDrop = (files, event, target) => {
    let fileUrl = URL.createObjectURL(files[0]);
    this.setState({
      [target + "Url"]: fileUrl,
      [target + "Caution"]: false
    }, ()=> {
      if(files[0].type.startsWith('image/')){
        this.setState({
          [target]: files[0]
        })
      }else{
        this.setState({
          [target + "Caution"]: true
        })
      }
    })
  }

  uploadImage = async (file, fileName, prefix) => {
    const fileNameSplit = file.name.split(/(?=\.[^.]+$)/);
    const extension = fileNameSplit[fileNameSplit.length - 1]
    return await Storage.put(
      fileName + extension,
      file,
      {
        contentType: file.type,
        customPrefix: { public: basePath + prefix + "/"}
      }
    )
      .then(result => {
        console.log(result.key)
        return result.key
      })
      .catch(err => {
        console.log(err)
        throw err
      });
  };

  handleChangeSwitch = (event, key, status) => {
    const { enqueueSnackbar } = this.props;

    let check = event.target.checked;
    console.log("event.target.checked: ", check);
    console.log("key: ", key);

    let plans = this.state.extraPlans

    plans.some((item, i) => {
      if(item.extra_plan_id === key){
        let newItem = item
        let status
        if(check){
          status = "posted"
        }else{
          status = "notPosted"
        }
        newItem.status = status
        newItem.date = moment().format("YYYY-MM-DD HH:mm")

        let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
        let path = '/update-extra-plan'; //replace this with the path you have configured on your API
        let myInit = {
          body:{
            ...newItem
          }
        }

        API.post(apiName, path, myInit).then(response => {
          console.log(response);
          plans.splice(i,1,newItem);
          this.setExtraPlans(plans)
          enqueueSnackbar(response.message, {variant : 'success'});
        }).catch(error => {
          console.log(error)
          if(error.message){
            enqueueSnackbar(error.message, {variant : 'error'})
          }else{
            enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
          }
        });
      }
      return false;
    });
  }

  deleteExtraPlan = () => {
    const { enqueueSnackbar } = this.props;

    let id = this.state.deleteExtraPlanId

    let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
    let path = '/delete-extra-plan'; //replace this with the path you have configured on your API
    let myInit = {
      body:{extra_plan_id: id}
    }

    API.post(apiName, path, myInit).then(response => {
      console.log(response);
      enqueueSnackbar(response.message, {variant : 'success'});

      let plans = this.state.extraPlans

      plans.some((item, i) => {
        if(item.extra_plan_id === id){
          plans.splice(i,1);
          this.setExtraPlans(plans)
          this.setState({
            deleteOpen: false,
            deleteExtraPlanId: ""
          })
        }
        return false;
      });

    }).catch(error => {
      console.log(error)
      if(error.message){
        enqueueSnackbar(error.message, {variant : 'error'})
      }else{
        enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
      }
    });
  }

  handleDeleteOpen = (id) => {
    this.setState({
      deleteExtraPlanId: id,
      deleteOpen: true
    })
  }

  getFile = async (fullPath) => {
    let fullPathArray = fullPath.split("/")

    let fileName = fullPathArray[fullPathArray.length -1]

    fullPathArray.pop()
    let pathArray =  fullPathArray

    let path = pathArray.join('/') + '/'

    console.log(fileName)
    console.log(path)


    return await Storage.get(fileName,{
      customPrefix: { public: path}
    });
  }

  handleRefOpen = async (id) => {
    let refExtraPlan

    this.state.extraPlans.map((plan)=> {
      if(plan.extra_plan_id === id){
        refExtraPlan = plan
      }
      return false
    })

    console.log("refExtraPlan: ", refExtraPlan)

    let topImageFileUrl = await this.getFile(refExtraPlan.top_image_path)

    refExtraPlan.main_images_paths.sort((a, b) => {
      if (a.priority > b.priority) {
        return 1;
      } else {
        return -1;
      }
    })

    let mainImage1FileUrls = await this.getFile(refExtraPlan.main_images_paths[0].path)

    let mainImage2FileUrls
    if(refExtraPlan.main_images_paths.length > 1){
      mainImage2FileUrls = await this.getFile(refExtraPlan.main_images_paths[1].path)
    }

    this.setState({
      refExtraPlanId: id,
      refOpen: true,

      refTitle: refExtraPlan.title,
      refSubTitle: refExtraPlan.sub_title,
      refBody: refExtraPlan.body,
      refPrice: refExtraPlan.price,
      refPriority: refExtraPlan.priority,
      refTopImageUrl: topImageFileUrl,
      refMainImage1Url: mainImage1FileUrls,
      refMainImage2Url: mainImage2FileUrls ? mainImage2FileUrls : '',
    })
  }

  handleCloseDialog = (key) => {
    this.setState({
      [key]: false,
      deleteExtraPlanId: "",
      refExtraPlanId: "",
      refTitle: "",
      refSubTitle: "",
      refBody: "",
      refPrice: "",
      refPriority: "",
      refTopImageUrl: "",
      refMainImage1Url: "",
      refMainImage2Url: "",
    })
  }

  submit = async () => {
    this.setState({
      executing: true
    }, async () => {
      const { enqueueSnackbar } = this.props;
      if(this.state.topImage && this.state.mainImage1){
        const uuid = uuidv4()

        let topImagePath
        let main1ImagePath
        let main2ImagePath

        let mainImagesPaths = []

        try{
          let topFileName = await this.uploadImage(this.state.topImage, "top", uuid);
          let main1FileName = await this.uploadImage(this.state.mainImage1, "main1", uuid);

          topImagePath = basePath + uuid + "/" + topFileName
          main1ImagePath = basePath + uuid + "/" + main1FileName
          mainImagesPaths.push({
            priority: 1,
            path: main1ImagePath
          })

          if(this.state.mainImage2){
            let main2FileName = await this.uploadImage(this.state.mainImage2, "main2", uuid);
            main2ImagePath = basePath + uuid + "/" + main2FileName
            mainImagesPaths.push({
              priority: 2,
              path: main2ImagePath
            })
          }

          let apiName = 'MyAPIGatewayAPI'; // replace this with your api name.
          let path = '/add-extra-plan'; //replace this with the path you have configured on your API

          console.log(topImagePath)
          console.log(main1ImagePath)
          console.log(main2ImagePath)

          console.log(mainImagesPaths)

          let myInit = {
            body: {
              title: this.state.title,
              sub_title: this.state.subTitle,
              body: this.state.body,
              top_image_path: topImagePath,
              main_images_paths: mainImagesPaths,
              price: this.state.price,
              priority: this.state.priority,
            }
          }

          console.log(myInit)

          API.post(apiName, path, myInit).then(response => {
            console.log(response);
            enqueueSnackbar(response.message, {variant : 'success'});
            this.setState({
              title: "",
              subTitle: "",
              body: "",
              price: "",
              priority: "",
              topImage: "",
              topImageUrl: "",
              topImageCaution: false,
              mainImage1: "",
              mainImage1Url: "",
              mainImage1Caution: false,
              mainImage2: "",
              mainImage2Url: "",
              mainImage2Caution: false,
              executing: false
            },() => {
              this.getExtraPlans();
            })
          }).catch(error => {
            console.log(error)
            if(error.message){
              enqueueSnackbar(error.message, {variant : 'error'})
            }else{
              enqueueSnackbar('エラーが発生しました。', {variant : 'error'})
            }
            this.setState({
              executing: false
            })
          });
        }catch(e){
          console.log('err: ' + e);
          enqueueSnackbar('ERROR もう一度登録してください', {variant : 'error'});
          this.setState({
            executing: false
          })
        }
      }else{
        enqueueSnackbar('トップバナー画像とメイン画像1を登録してください', {variant : 'error'});
        this.setState({
          executing: false
        })
      }
    })
  }

  render() {
    const {classes} = this.props

    const {
      title,
      subTitle,
      body,
      price,
      priority,
      topImage,
      topImageUrl,
      topImageCaution,
      mainImage1,
      mainImage1Url,
      mainImage1Caution,
      mainImage2,
      mainImage2Url,
      mainImage2Caution,
      refTitle,
      refSubTitle,
      refBody,
      refPrice,
      refPriority,
      refTopImageUrl,
      refMainImage1Url,
      refMainImage2Url,
      extraPlans,
      extraPlansPosted,
      extraPlansNotPosted,
      executing,
      deleteOpen,
      refOpen,
      scroll
    } = this.state;

    extraPlansPosted.sort((a, b) => {
      if (a.priority > b.priority) {
        return 1;
      } else {
        return -1;
      }
    })

    return (
      <Fragment>
        <Grid container spacing={24} className={classes.container}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom>
              追加プラン管理
            </Typography>
          </Grid>
          <Grid item>
            <Paper className={classes.root} elevation={1}>
              <Typography variant="h6" gutterBottom>
                追加プラン登録
              </Typography>

              <ValidatorForm
                ref="form"
                onSubmit={() => this.submit()}
                onError={
                  errors => {
                    console.log(errors);
                    const { enqueueSnackbar } = this.props;
                    enqueueSnackbar('任意の項目が不正です', {variant : 'warning'});
                  }
                }
              >
                <TextValidator
                  className={classes.textField}
                  name="title"
                  label="タイトル"
                  value={title}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'title')}
                  required={true}
                  validators={['required']}
                  errorMessages={['必須項目を入力してください']}
                  type="text"
                  style={{marginTop: 30}}
                  helperText={"22文字までを目安に (現在 " + title.length + "文字)"}
                />
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="subTitle"
                  label="サブタイトル"
                  value={subTitle}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'subTitle')}
                  required={true}
                  validators={['required']}
                  errorMessages={['必須項目を入力してください']}
                  type="text"
                  style={{marginTop: 10}}
                  helperText={"20文字までを目安に (現在 " + subTitle.length + "文字)"}
                />
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="body"
                  label="本文"
                  value={body}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'body')}
                  required={true}
                  validators={['required']}
                  errorMessages={['必須項目を入力してください']}
                  multiline={true}
                  rows={12}
                  style={{marginTop: 10, width:500 }}
                  helperText={"200文字前後を目安に (現在 " + body.length + "文字)"}
                />
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="price"
                  label="価格"
                  value={price}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'price')}
                  type="number"
                  required={true}
                  validators={['required', 'isNumber', 'minNumber:0']}
                  errorMessages={['必須項目を入力してください', '整数を入力してください', '0以上の数を入力してください']}
                  style={{marginTop: 10, width:200}}
                  helperText={"価格を0にするとHPに表示しません"}
                />
                <br/>
                <TextValidator
                  className={classes.textField}
                  name="priority"
                  label="表示順位"
                  value={priority}
                  margin="normal"
                  onChange={(e) => this.handleChange(e, 'priority')}
                  type="number"
                  required={true}
                  validators={['required', 'isFloat']}
                  errorMessages={['必須項目を入力してください', '数値を入力してください']}
                  style={{marginTop: 10, width:200}}
                  helperText="小数可 小さい数字を上位に掲載"
                />

                <h5 style={{
                  color: "#0000008a",
                  margin: "40px 0 0 7px",
                  fontWeight: "normal"
                }}>
                  トップバナー画像
                </h5>
                <div
                  onClick={e => {
                    this.uploadTopImage.value = null;
                    this.uploadTopImage.click();
                  }}
                >
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    ref={ref => (this.uploadTopImage = ref)}
                    onChange={(e) => this.handleDrop(this.uploadTopImage.files, e, "topImage")}
                  />
                  <FileDrop onDrop={(file, event) => this.handleDrop(file, event, "topImage")}>
                    <div
                      id="react-file-drop-demo"
                      style={{
                        border: "1px solid #0000008a",
                        color: topImageUrl ? "white" : "#0000008a" ,
                        fontSize: "0.8em",
                        width: 400,
                        height: 100,
                        margin: "0 0 0 7px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundImage: topImageUrl ? "url(" + topImageUrl + ")" : "",
                        backgroundSize: "cover",
                        backgroundPosition:"center center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      {!topImageCaution && !topImageUrl ? "画像をドロップ または 選択" : ""}
                      {!topImageCaution && topImageUrl ? "画像を変更" : ""}
                      {topImageCaution &&
                        <div style={{color: "#0000008a"}}>
                          画像ファイルを選択してください
                        </div>
                      }
                    </div>
                  </FileDrop>
                </div>
                <h6 style={{
                  color: "#0000008a",
                  margin: "5px 0 0 7px",
                  fontWeight: "normal"
                }}>
                  {topImage &&
                    "画像サイズ"  + humanFileSize(topImage.size)
                  }
                  {topImage.size > 1048576 &&
                    <Fragment>
                      <br/><div style={{color: "red"}}>画像サイズは1MB以下を推奨します</div>
                    </Fragment>
                  }
                </h6>

                <h5 style={{
                  color: "#0000008a",
                  margin: "20px 0 0 7px",
                  fontWeight: "normal"
                }}>
                  メイン画像1
                </h5>
                <div
                  onClick={e => {
                    this.uploadMainImage1.value = null;
                    this.uploadMainImage1.click();
                  }}
                >
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    ref={ref => (this.uploadMainImage1 = ref)}
                    onChange={(e) => this.handleDrop(this.uploadMainImage1.files, e, "mainImage1")}
                  />
                  <FileDrop onDrop={(file, event) => this.handleDrop(file, event, "mainImage1")}>
                    <div
                      id="react-file-drop-demo"
                      style={{
                        border: "1px solid #0000008a",
                        color: mainImage1Url ? "white" : "#0000008a" ,
                        fontSize: "0.8em",
                        width: 455,
                        height: 302,
                        margin: "0 0 0 7px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundImage: mainImage1Url ? "url(" + mainImage1Url + ")" : "",
                        backgroundSize: "cover",
                        backgroundPosition:"center center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      {!mainImage1Caution && !mainImage1Url ? "画像をドロップ または 選択" : ""}
                      {!mainImage1Caution && mainImage1Url ? "画像を変更" : ""}
                      {mainImage1Caution &&
                        <div style={{color: "#0000008a"}}>
                          画像ファイルを選択してください
                        </div>
                      }
                    </div>
                  </FileDrop>
                </div>
                <h6 style={{
                  color: "#0000008a",
                  margin: "5px 0 0 7px",
                  fontWeight: "normal"
                }}>
                  {mainImage1 &&
                    "画像サイズ"  + humanFileSize(mainImage1.size)
                  }
                  {mainImage1.size > 1048576 &&
                    <Fragment>
                      <br/><div style={{color: "red"}}>画像サイズは1MB以下を推奨します</div>
                    </Fragment>
                  }
                </h6>

                <h5 style={{
                  color: "#0000008a",
                  margin: "20px 0 0 7px",
                  fontWeight: "normal"
                }}>
                  メイン画像2
                </h5>
                <div
                  onClick={e => {
                    this.uploadMainImage2.value = null;
                    this.uploadMainImage2.click();
                  }}
                >
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    ref={ref => (this.uploadMainImage2 = ref)}
                    onChange={(e) => this.handleDrop(this.uploadMainImage2.files, e, "mainImage2")}
                  />
                  <FileDrop onDrop={(file, event) => this.handleDrop(file, event, "mainImage2")}>
                    <div
                      id="react-file-drop-demo"
                      style={{
                        border: "1px solid #0000008a",
                        color: mainImage2Url ? "white" : "#0000008a" ,
                        fontSize: "0.8em",
                        width: 455,
                        height: 302,
                        margin: "0 0 0 7px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundImage: mainImage2Url ? "url(" + mainImage2Url + ")" : "",
                        backgroundSize: "cover",
                        backgroundPosition:"center center",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      {!mainImage2Caution && !mainImage2Url ? "画像をドロップ または 選択" : ""}
                      {!mainImage2Caution && mainImage2Url ? "画像を変更" : ""}
                      {mainImage2Caution &&
                        <div style={{color: "#0000008a"}}>
                          画像ファイルを選択してください
                        </div>
                      }
                    </div>
                  </FileDrop>
                </div>
                <h6 style={{
                  color: "#0000008a",
                  margin: "5px 0 0 7px",
                  fontWeight: "normal"
                }}>
                  {mainImage2 &&
                    "画像サイズ"  + humanFileSize(mainImage2.size)
                  }
                  {mainImage2.size > 1048576 &&
                    <Fragment>
                      <br/><div style={{color: "red"}}>画像サイズは1MB以下を推奨します</div>
                    </Fragment>
                  }
                </h6>

                <Button
                  type="submit"
                  variant="contained"
                  color="default"
                  className={classes.button}
                  style={{marginLeft:"85%", marginTop:40}}
                  disabled={executing ? true : false}
                >
                  登録
                </Button>
              </ValidatorForm>
            </Paper>

            <Paper className={classes.root} elevation={1} style={{marginTop: 40}}>
              <Typography variant="h6" gutterBottom>
                追加プラン掲載管理
              </Typography>

              <div style={{
                color: "#0000008a",
                margin: "20px 0 0 7px",
                fontWeight: "normal",
                display: extraPlans.length > 0 ? "none" : ""
              }}>
                プランがありません
              </div>

              <h5 style={{
                color: "#0000008a",
                margin: "20px 0 0 7px",
                fontWeight: "normal",
                display: extraPlansPosted.length > 0 ? "" : "none"
              }}>
                掲載中の追加プラン
              </h5>
              <Table className={classes.table} style={{marginTop: 10}}>
                <TableHead style={{backgroundColor:"#f3f3f3", display: extraPlansPosted.length > 0 ? "" : "none"}}>
                  <TableRow>
                    <TableCell style={{color: "#676767"}} align="left" padding="dense">タイトル</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">掲載順位</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">最終更新日時</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">掲載状態</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {extraPlansPosted.map(n => {
                  return(
                    <TableRow key={n.extra_plan_id}>
                      <TableCell align="left" padding="dense">{n.title}</TableCell>
                      <TableCell align="right" padding="dense">{n.priority}</TableCell>
                      <TableCell align="center" padding="dense">
                        {moment(n.date).format('YYYY年M月D日')}<br/>
                        {moment(n.date).format('H:mm')}
                      </TableCell>
                      <TableCell align="center" padding="dense">
                        <FormControlLabel
                          control={
                            <Switch
                              checked={n.status === "posted" ? true : false}
                              onChange={(e) => this.handleChangeSwitch(e, n.extra_plan_id, n.status)}
                              value={n.extra_plan_id}
                              color="primary"
                            />
                          }
                          label="掲載"
                        />
                        </TableCell>
                        <TableCell align="left" padding="dense">
                        <Button
                          type="submit"
                          variant="contained"
                          color="default"
                          className={classes.button}
                          onClick={() => this.handleRefOpen(n.extra_plan_id)}
                          style={{marginTop:10, marginBottom:5}}
                        >
                          <ListItemIcon><SvgIcon size={18} icon={fileTextO}/></ListItemIcon>
                          参照
                        </Button>
                        <br/>
                        <Button
                          type="submit"
                          variant="contained"
                          color="default"
                          className={classes.button}
                          onClick={() => this.handleDeleteOpen(n.extra_plan_id)}
                          style={{marginTop:10, marginBottom:5}}
                        >
                          <ListItemIcon><SvgIcon size={18} icon={remove}/></ListItemIcon>
                          削除
                        </Button>
                      </TableCell>
                    </TableRow>
                  )
                })}
                </TableBody>
              </Table>

              <h5 style={{
                color: "#0000008a",
                margin: extraPlansPosted.length > 0 ?  "60px 0 0 7px" : "20px 0 0 7px" ,
                fontWeight: "normal",
                display: extraPlansNotPosted.length > 0 ? "" : "none"
              }}>
                非掲載の追加プラン
              </h5>
              <Table className={classes.table} style={{marginTop: 10}}>
                <TableHead style={{backgroundColor:"#f3f3f3", display: extraPlansNotPosted.length > 0 ? "" : "none"}}>
                  <TableRow>
                    <TableCell style={{color: "#676767"}} align="left" padding="dense">タイトル</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">掲載順位</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">最終更新日時</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense">掲載状態</TableCell>
                    <TableCell style={{color: "#676767"}} align="center" padding="dense"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {extraPlansNotPosted.map(n => {
                  return(
                    <TableRow key={n.extra_plan_id}>
                      <TableCell align="left" padding="dense">{n.title}</TableCell>
                      <TableCell align="right" padding="dense">{n.priority}</TableCell>
                      <TableCell align="center" padding="dense">
                        {moment(n.date).format('YYYY年M月D日')}<br/>
                        {moment(n.date).format('H:mm')}
                      </TableCell>
                      <TableCell align="center" padding="dense">
                        <FormControlLabel
                          control={
                            <Switch
                              checked={n.status === "posted" ? true : false}
                              onChange={(e) => this.handleChangeSwitch(e, n.extra_plan_id, n.status)}
                              value={n.extra_plan_id}
                              color="primary"
                            />
                          }
                          label="掲載"
                        />
                        </TableCell>
                        <TableCell align="left" padding="dense">
                        <Button
                          type="submit"
                          variant="contained"
                          color="default"
                          className={classes.button}
                          onClick={() => this.handleRefOpen(n.extra_plan_id)}
                          style={{marginTop:10, marginBottom:5}}
                        >
                          <ListItemIcon><SvgIcon size={18} icon={fileTextO}/></ListItemIcon>
                          参照
                        </Button>
                        <br/>
                        <Button
                          type="submit"
                          variant="contained"
                          color="default"
                          className={classes.button}
                          onClick={() => this.handleDeleteOpen(n.extra_plan_id)}
                          style={{marginTop:10, marginBottom:5}}
                        >
                          <ListItemIcon><SvgIcon size={18} icon={remove}/></ListItemIcon>
                          削除
                        </Button>
                      </TableCell>
                    </TableRow>
                  )
                })}
                </TableBody>
              </Table>

            </Paper>

          </Grid>
        </Grid>


        <Dialog
          open={deleteOpen}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleCloseDialog('deleteOpen')}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            追加プランを削除してよろしいですか？
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              削除した追加プランは、<br/>
              もとに戻すことができません。<br/><br/>
              もう一度追加プランを掲載する際には、新しい追加プランを作成してください。
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleCloseDialog('deleteOpen')} color="primary">
              いいえ
            </Button>
            <Button onClick={this.deleteExtraPlan} color="primary">
              はい
            </Button>
          </DialogActions>
        </Dialog>


        <Dialog
          open={refOpen}
          onClose={() => this.handleCloseDialog('refOpen')}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          fullWidth={true}
          maxWidth="md"
        >
          <DialogTitle id="scroll-dialog-title">追加プラン参照</DialogTitle>
          <DialogContent>
          <div style={{fontSize:"0.8em", color: "#0000008a", margin: "0 0 0 7px"}}>タイトル:</div>
          <div style={{fontSize:"1em", color: "#000000de", margin: "5px 0 0 15px"}}>{refTitle}</div>

          <div style={{fontSize:"0.8em", color: "#0000008a", margin: "30px 0 0 7px"}}>サブタイトル:</div>
          <div style={{fontSize:"1em", color: "#000000de", margin: "5px 0 0 15px"}}>{refSubTitle}</div>

          <div style={{fontSize:"0.8em", color: "#0000008a", margin: "30px 0 0 7px"}}>本文:</div>
          <div style={{fontSize:"1em", color: "#000000de", margin: "5px 30px 0 15px", whiteSpace: 'pre-line'}}>{refBody}</div>

          <div style={{fontSize:"0.8em", color: "#0000008a", margin: "30px 0 0 7px"}}>価格:</div>
          <div style={{fontSize:"1em", color: "#000000de", margin: "5px 0 0 15px"}}>{refPrice} 円</div>

          <div style={{fontSize:"0.8em", color: "#0000008a", margin: "30px 0 0 7px"}}>表示順位:</div>
          <div style={{fontSize:"1em", color: "#000000de", margin: "5px 0 0 15px"}}>{refPriority}</div>

          <h5 style={{
            color: "#0000008a",
            margin: "40px 0 0 7px",
            fontWeight: "normal"
          }}>
            トップバナー画像
          </h5>
          <div
            id="react-file-drop-demo"
            style={{
              width: 400,
              height: 100,
              margin: "0 0 0 7px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundImage: refTopImageUrl ? "url(" + refTopImageUrl + ")" : "",
              backgroundSize: "cover",
              backgroundPosition:"center center",
              backgroundRepeat: "no-repeat",
            }}
          >
          </div>

          <h5 style={{
            color: "#0000008a",
            margin: "20px 0 0 7px",
            fontWeight: "normal"
          }}>
            メイン画像1
          </h5>
          <div
            id="react-file-drop-demo"
            style={{
              width: 455,
              height: 302,
              margin: "0 0 0 7px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundImage: refMainImage1Url ? "url(" + refMainImage1Url + ")" : "",
              backgroundSize: "cover",
              backgroundPosition:"center center",
              backgroundRepeat: "no-repeat",
            }}
          >
          </div>

          <h5 style={{
            color: "#0000008a",
            margin: "20px 0 0 7px",
            fontWeight: "normal"
          }}>
            メイン画像2
          </h5>
          <div
            id="react-file-drop-demo"
            style={{
              width: 455,
              height: 302,
              margin: "0 0 0 7px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundImage: refMainImage2Url ? "url(" + refMainImage2Url + ")" : "",
              backgroundSize: "cover",
              backgroundPosition:"center center",
              backgroundRepeat: "no-repeat",
            }}
          >
          </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.handleCloseDialog('refOpen')} color="primary">
              閉じる
            </Button>
          </DialogActions>
        </Dialog>


      </Fragment>
    );
  }
}

ExtraPlans.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withSnackbar(withRouter(withStyles(styles, { withTheme: true })(ExtraPlans)));
